define(
    'providers/dataprovider.folders',[
        "services/config"
    ],
    function(config) {
        function getFolderById(folderId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-folder-by-id",
                    data: { folderId: folderId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getLibraryFolders(libraryId) {
            var data = { libraryId: libraryId };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-library-folders",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getLibraryListValueFolders(libraryId, listValueId) {
            var data = { libraryId: libraryId, listValueId: listValueId };
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-library-list-value-folders",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getFavouriteFolders() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-favourite-folders",
                    data: {},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getSharedUploadRequests(lastdays, isMy) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-folders-shared-upload-requests",
                    data: { my: (!isMy ? "" : "/my"), lastdays: lastdays },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getSharedUploadRequestDetails(id) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-folders-shared-upload-request-details",
                    data: { folderShareId : id},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function cancelSharedUploadRequest(id) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-folders-cancel-shared-upload-request",
                    data: { id: id },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function favouriteFolder(folderId, name) {
            return markFolder({ folderId: folderId, name: name }, "favourite-folder");
        }
        function unfavouriteFolder(folderId) {
            return markFolder({ folderId: folderId }, "unfavourite-folder");
        }

        function getFolderActionPermissions(folderId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-folder-action-permissions",
                    data: { folderId: folderId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function addFolderAndGet(parentFolderId, name) {
            var d = $.Deferred();

            addFolder(parentFolderId, name)
            .done(function (id) {
                getFolderById(id)
                .done(function (data) {
                    d.resolve(data);
                })
                .fail(function (e) {
                    d.reject(e);
                });
            })
            .fail(function (e) {
                d.reject(e);
            });

            return d.promise();
        }
        function addFolder(parentFolderId, name) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "add-folder",
                    data: { parentFolderId: parentFolderId, name: name },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function renameFolder(folderId, name) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "rename-folder",
                    data: { folderId: folderId, name: name},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function deleteFolder(folderId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "delete-folder",
                    data: { folderId: folderId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function addFolderShare(data) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "add-folder-share",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getFolderShareById(folderId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-folder-share-by-id",
                    data: { folderId: folderId },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }        

        init();

        return {
            getFolderById: getFolderById,
            getLibraryFolders: getLibraryFolders,
            getLibraryListValueFolders: getLibraryListValueFolders,
            getFavouriteFolders: getFavouriteFolders,
            getSharedUploadRequests: getSharedUploadRequests,
            getSharedUploadRequestDetails: getSharedUploadRequestDetails,
            cancelSharedUploadRequest: cancelSharedUploadRequest,
            favouriteFolder: favouriteFolder,
            unfavouriteFolder: unfavouriteFolder,
            getFolderActionPermissions: getFolderActionPermissions,
            addFolderAndGet: addFolderAndGet,
            addFolder: addFolder,
            renameFolder: renameFolder,
            deleteFolder: deleteFolder,
            addFolderShare: addFolderShare,
            getFolderShareById: getFolderShareById,            
        };

        //#region Internal Methods
        function init() {
            amplify.request.define("get-folder-by-id", "ajax", {
                url: getUrl("folders/{folderId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-library-folders", "ajax", {
                url: getUrl("folders/libraries/{libraryId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-library-list-value-folders", "ajax", {
                url: getUrl("folders/libraries/{libraryId}/list-values/{listValueId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-favourite-folders", "ajax", {
                url: getUrl("folders/favourite"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-folders-shared-upload-requests", "ajax", {
                url: getUrl("foldershares/list{my}/{lastdays}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-folders-shared-upload-request-details", "ajax", {
                url: getUrl("foldershares/details/{folderShareId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("put-folders-cancel-shared-upload-request", "ajax", {
                url: getUrl("foldershares/cancel/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT"
            });
            
            amplify.request.define("favourite-folder", "ajax", {
                url: getUrl("folders/{folderId}/favourite"),
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return data.name;
                }
            });

            amplify.request.define("unfavourite-folder", "ajax", {
                url: getUrl("folders/{folderId}/unfavourite"),
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("get-folder-action-permissions", "ajax", {
                url: getUrl("folders/{folderId}/permissions"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("add-folder", "ajax", {
                url: getUrl("folders"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("rename-folder", "ajax", {
                url: getUrl("folders/{folderId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return data.name;
                }
            });

            amplify.request.define("delete-folder", "ajax", {
                url: getUrl("folders/{folderId}"),
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("add-folder-share", "ajax", {
                url: getUrl("folders/{folderId}/share"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("get-folder-share-by-id", "ajax", {
                url: getUrl("foldershares/recipient/{folderId}/includedocuments"),
                dataType: "json",
                type: "GET"
            });
        }


        function markFolder(data, resourceId) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: resourceId,
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }


        function getUrl(action) {
            return config.webApiUrl + action;
        }

        //#endregion
    }
);
